import React from "react";
import "../components/styles/ListElement.css";
import { phpServerLink, userImageUrl } from "../services/apicalls.js";
import { avatar } from "../constants/images.js";
const ListElement = ({ data }) => {
  return (
    <div className="elementMainDiv">
      <img
        src={
          data?.userPicturePath !== ""
            ? phpServerLink + data?.userPicturePath
            : avatar
        }
        alt={`${data?.firstName} ${data?.lastName}`}
        onError={(e) => {
          e.target.onerror = null; // Prevents looping
          e.target.src = avatar; // Fallback URL for the image
        }}
      />
      <div className="nameDiv">
        <h4>{`${data?.firstName} ${data?.lastName}`}</h4>
        <p>@{data?.username}</p>
      </div>
    </div>
  );
};

export default ListElement;
